import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ContinueWithBackAndTempSaveButtons } from 'components/base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from 'components/campaign/campaignCreation/CampaignStepTwoPreviewConfig';

import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';
import { CREATE_EVENT_CONTENT_PAGE_CONFIG } from 'containers/engagement/events/EventCreationConfig';

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});
const CreateEventContentPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  onStepChange,
  onSaveTemp,
}) => {
  const currentStep = 0;
  const params = useParams();
  const formContext = useFormContext()
  const {
    watch,
    formState: { errors },
    setValue,
  } = formContext;


  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];

  const defaultCampaignType = CampaignType.ticketCampaign;
  const campaignTypeField = 'campaignType';
  const watchCampaignType = watch(campaignTypeField);

  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  const defaultImage = defaultPreviewImage(CampaignType.ticketCampaign);
  const inputWithImageConfig = getPreviewLayoutImages(CampaignType.ticketCampaign);

  useEffect(()=>{
    if (watchCampaignType !== defaultCampaignType) {
      setValue(campaignTypeField, defaultCampaignType, { shouldDirty: true })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchCampaignType])

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);


  const goToNextStep = () => {
    setFieldsError(0);
    onStepChange(currentStep + 1)
  }

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_EVENT_CONTENT_PAGE_CONFIG}
        hidePreview={false}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
        sectionStyle='create-campaign-streamline-step-2'
      />
      <ContinueWithBackAndTempSaveButtons
        {...params.id ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            onSaveTemp && onSaveTemp(formContext)
          }
        }}
        continueAction={goToNextStep}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={defaultCampaignType}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/events'}
      />
    </>
  );
}

export default connect(mapStateToProps)(CreateEventContentPage);
